import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { ApiMethod } from './types';

interface MethodBadgeProps {
    method: ApiMethod | string;
}

const METHOD_CLASS: Record<string, string> = {
    GET: 'methodGet',
    POST: 'methodPost',
    PUT: 'methodPut',
    DELETE: 'methodDelete',
    PATCH: 'methodPatch',
};

/*
 * Color-coded pill badge for an HTTP method, shared across the catalog list, detail page,
 * and API Management endpoint rows.
 */
export function MethodBadge({ method }: MethodBadgeProps) {
    return <span className={classNames(styles.badge, styles[METHOD_CLASS[method]])}>{method}</span>;
}
